import { PublicKey } from '@solana/web3.js';
export default function validateSolAddress(address) {
    try {
        var pubkey = new PublicKey(address);
        var isSolana = PublicKey.isOnCurve(pubkey.toBuffer());
        console.log('isSolana address', isSolana, address);
        return isSolana;
    }
    catch (error) {
        return false;
    }
}
